import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../features/auth/authAPI';
import { useNavigate } from 'react-router-dom';
import "./LoginPage.css";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const status = useSelector((state) => state.auth.status);
  const error = useSelector((state) => state.auth.error);
  const token = useSelector((state) => state.auth.token);

  const handleLogin = async (e) => {
    e.preventDefault();
    dispatch(loginUser({ email, password })).then((action) => {
      if (action.type === "auth/loginUser/fulfilled") {
        navigate("/dashboard");
      }
    });
  };

  useEffect(() => {
    if (token) {
      navigate('/creatjobs');
    }
  }, [navigate, token]);


  return (
    <div className="login-page-container">
    {/* Left side with branding image (30%) */}
    <div className="branding-section">
      <div className="branding-content">
        <img src="codexllnc.png" alt="PPR International Logo" className="brand-logo" />
        <h1 className="brand-tagline">CODE XLNC</h1>
      </div>
    </div>
  
    {/* Right side with login form (70%) */}
    <div className="login-section">
      <div className="login-container">
        {status === 'loading' && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
            <p>Authenticating...</p>
          </div>
        )}
        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}
        
        <div className="login-box">
          <div className="login-header">
            <h2>Welcome back!</h2>
            <p>Code XLNC Login</p>
          </div>
  
          <form onSubmit={handleLogin} className="login-form">
            <div className="form-group">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-input"
              />
            </div>
            
            <div className="form-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input"
              />
            </div>
  
            <div className="login-options">
              <label className="remember-me">
                <input type="checkbox" /> 
                <span>Remember Me</span>
              </label>
            </div>
  
            <button 
              type="submit" 
              className="login-button"
              disabled={status === 'loading'}
            >
              {status === 'loading' ? (
                <span className="button-loader"></span>
              ) : (
                'Log In'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  );
}


export default Login;
